import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

export default function GridItem(props) {
  const { children, ...rest } = props;
  return (
    <Grid {...rest} sx={{ padding: "0 15px !important" }}>
      {children}
    </Grid>
  );
}

GridItem.propTypes = {
  children: PropTypes.node,
};
